import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Navigation from "./components/sections/Navigation";
import Hero from "./components/sections/Hero";
import Problem from "./components/sections/Problem";
import Products from "./components/sections/Products";
import HowItWorks from "./components/sections/HowItWorks";
import Pricing from "./components/sections/Pricing";
import WhyPing from "./components/sections/WhyPing";
import Contact from "./components/sections/Contact";
import Footer from "./components/sections/Footer";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";
import RefundPolicy from "./pages/RefundPolicy";

const Home = () => {
  const location = useLocation();

  // When arriving here from another route with a hash (e.g. /#products),
  // smooth-scroll to the target section after the page mounts.
  useEffect(() => {
    if (!location.hash) return;
    const scrollToHash = () => {
      const el = document.querySelector(location.hash);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    };
    // Give the DOM a tick to render sections
    const t = setTimeout(scrollToHash, 80);
    return () => clearTimeout(t);
  }, [location]);

  return (
    <main data-testid="ping-landing" className="bg-white">
      <Navigation />
      <Hero />
      <Problem />
      <WhyPing />
      <HowItWorks />
      <Products />
      <Pricing />
      <Contact />
      <Footer />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
